var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLargeGeneration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3C1.5 2.72386 1.72386 2.5 2 2.5H14C14.2761 2.5 14.5 2.72386 14.5 3C14.5 3.27614 14.2761 3.5 14 3.5H2C1.72386 3.5 1.5 3.27614 1.5 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.33337C1.5 6.05723 1.72386 5.83337 2 5.83337H14C14.2761 5.83337 14.5 6.05723 14.5 6.33337C14.5 6.60952 14.2761 6.83337 14 6.83337H2C1.72386 6.83337 1.5 6.60952 1.5 6.33337Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.66663C1.5 9.39048 1.72386 9.16663 2 9.16663H14C14.2761 9.16663 14.5 9.39048 14.5 9.66663C14.5 9.94277 14.2761 10.1666 14 10.1666H2C1.72386 10.1666 1.5 9.94277 1.5 9.66663Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 13C1.5 12.7239 1.72386 12.5 2 12.5H14C14.2761 12.5 14.5 12.7239 14.5 13C14.5 13.2761 14.2761 13.5 14 13.5H2C1.72386 13.5 1.5 13.2761 1.5 13Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeGeneration);
export default __webpack_public_path__ + "static/media/largeGeneration.df95924c.svg";
export { ForwardRef as ReactComponent };